module.exports = __webpack_public_path__ + "img/3st.9a42c7a.png";